import React from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';
import classes from './style.module.scss';

export default ({ children, image, customClasses ,...rest }) => {
    useStyles(classes);

    return (
        <div 
            className={
                customClasses 
                    ? `${classes.container} ${customClasses.container}` 
                    : classes.container
            }
            {...rest}
        >
            <div className={classes.button}>
                <div className={classes.imageContainer}>
                    {
                        image &&
                            <>
                                <img
                                    className={ 
                                        customClasses 
                                            ? `${classes.image} ${customClasses.image}` 
                                            : classes.image 
                                    }
                                    src={image.url} 
                                    alt={image.alt} 
                                    title={image.title} 
                                    height={image.height} 
                                />
                                <span className={classes.overlay} />
                            </>
                    }
                </div>
                {
                    children &&
                        <div className={classes.content}>
                            { children }
                        </div>
                }
            </div>
        </div>
    )
}
